<template>
  <div>
    <Drawer
      :closable="false"
      v-model="logisticsChannelDrawer"
      width="1000"
      :title="$t('key1000222')"
      :transfer="false"
      :lock-scroll="true"
      class-name="logisticsChannelStyle"
      @on-visible-change="visibleChange">
      <!--未启用物流方式-->
      <Button class="options_boxs" v-if="optionsType === 'selfOwnedLogistics' && getPermission('ymsSupplierCarrierShippingMethod_enable')"
        icon="md-add" type="primary" @click="getLogisticsNotEnabledData(carrierId)">{{ $t('key1005221') }}</Button>
      <!--筛选-->
      <div class="filter_box">
        <span>{{ $t('key1005219') }}</span>
        <Input v-model.trim="logisticsChannelText" clearable style="width: 250px;"></Input>
      </div>
      <!--列表-->
      <Table highlight-row border :columns="logistiChannelColumns" :data="logistiChannelData" max-height="750"></Table>
    </Drawer>
    <!--自有物流渠道弹窗-->
    <ownLogisticsChannelsModal ref="ownLogisticsChannels" @updateData="updateData"></ownLogisticsChannelsModal>
    <!--第三方物流渠道弹窗-->
    <thirdPartyLogisticsChannelsModal ref="thirdPartyLogisticsChannels"></thirdPartyLogisticsChannelsModal>
    <!--未启用物流弹窗-->
    <Modal v-model="logisticsNotEnabledModal" :title="$t('key1007125')" :transfer="false"
      :mask-closable="false" @on-visible-change="logisticsNotEnabledChange">
      <div class="flex align-items-center mb20">
        <span>{{ $t('key1004643') }}</span>
        <Cascader class="width_380" :data="logisticsNotEnabledData" v-model="logisticsNotEnabledValue" filterable></Cascader>
      </div>
      <template #footer>
        <Button @click="logisticsNotEnabledModal = false">{{ $t('key1000112') }}</Button>
        <Button type="primary" :disabled="logisticsNotEnabledValue.length ===0" @click="logisticsNotEnabledBtn">{{ $t('key1000111') }}</Button>
      </template>
    </Modal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import ownLogisticsChannelsModal from "@/views/supplier/components/warehouseLogistics/ownLogisticsChannelsModal.vue";
import thirdPartyLogisticsChannelsModal from "@/views/supplier/components/warehouseLogistics/thirdPartyLogisticsChannelsModal.vue";
import {_handleMultilingualFields, isJSON} from "@/utils/common";

export default {
  name: 'supplierLogisticsChannels',
  mixins: [Mixin],
  props: {
    optionsType: { // 来源：selfOwnedLogistics--->自有物流、thirdPartyLogistics--->第三方物流
      type: String,
      default: null
    }
  },
  data() {
    return {
      logisticsChannelDrawer: false,
      logisticsChannelText: '',
      logistiChannelColumns: [],
      logistiChannelData: [],
      originalData: [],
      carrierId: null,
      apiInterface: '',
      disableSystemCarrierId: [],
      logisticsNotEnabledModal: false,
      logisticsNotEnabledData: [],
      logisticsNotEnabledValue: [],
      logisticsDetails: {}
    };
  },
  methods: {
    // 监听Drawer抽屉的状态
    visibleChange(value) {
      if (!value) {
        this.logisticsChannelText = '';
        this.originalData = [];
        this.logistiChannelColumns = [];
        this.logistiChannelData = [];
      }
    },
    // 初始化数据
    getSupplierLogisticsChannelData(obj) {
      let v = this;
      let {carrierId, apiInterface} = obj;
      v.logisticsDetails = JSON.parse(JSON.stringify(obj));
      v.handleColumns(apiInterface);
      v.logisticsChannelDrawer = true;
      v.carrierId = carrierId;
      v.apiInterface = apiInterface;
      let url = v.optionsType === 'thirdPartyLogistics' ? api.get_carrierShippingMethod_api_queryForThirdCarriersShoppingMethod
        : api.get_ymsSupplierCarrierShippingMethod_queryForEnableShippingMethods;
      v.axios.get(url + `?carrierId=${carrierId}&status=1`, {loading: true}).then(response => {
        if (response.data.code === 0) {
          let data = response.data.datas || [];
          v.logistiChannelData = data;
          v.originalData = JSON.parse(JSON.stringify(data));
          v.logisticsChannelDrawer = true;
        }
      });
    },
    // 处理列表字段
    handleColumns(apiInterface) {
      let v = this;
      let columnsList = [
        {
          key: 'carrierShippingMethodName',
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002818'),
          align: 'center',
          minWidth: 200,
          render(h, params) {
            let carrierShippingMethodName = _handleMultilingualFields(params.row.carrierShippingMethodName);
            return h('span', carrierShippingMethodName);
          }
        },
        {
          key: 'carrierShippingMethodCode',
          align: 'center',
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000409'),
          minWidth: 130
        },
        {
          key: 'logisticsInterface',
          align: 'center',
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005212'),
          minWidth: 150
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000410'),
          align: 'center',
          minWidth: 120,
          render: (h, params) => {
            let minEfficiency = params.row.minEfficiency;
            let maxEfficiency = params.row.maxEfficiency;
            let text = '';
            if (minEfficiency && !maxEfficiency) {
              text = minEfficiency + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001631');
            }
            if (maxEfficiency && !minEfficiency) {
              text = maxEfficiency + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001631');
            }
            if (minEfficiency && maxEfficiency) {
              text = minEfficiency + ' - ' + maxEfficiency + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001631');
            }
            return h('div', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003698'),
          align: 'center',
          minWidth: 100,
          render: (h, params) => {
            if (params.row.hasTrackingNumber) {
              return h('div', 'Y');
            } else {
              return h('div', 'N');
            }
          }
        }
      ];
      let options = {
        key: 'operate',
        align: 'center',
        title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
        minWidth: 150,
        render: (h, params) => {
          let isE = params.row.status === 1;
          let shippingMethodId = params.row.shippingMethodId;
          return h('optsButtonList', {
            props: {
              operationList: [
                {
                  text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000401'),
                  show: v.optionsType === 'selfOwnedLogistics',
                  clickFn: () => {
                    v.$refs['ownLogisticsChannels'].initSupplierLogisticsChannelData('look', shippingMethodId);
                  }
                },
                {
                  text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000669'),
                  show: v.optionsType === 'selfOwnedLogistics' && v.getPermission('ymsSupplierCarrierShippingMethod_update'),
                  clickFn: () => {
                    v.$refs['ownLogisticsChannels'].initSupplierLogisticsChannelData('edit', shippingMethodId);
                  }
                },
                {
                  text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000463'),
                  show: isE && v.optionsType === 'selfOwnedLogistics' && v.getPermission('ymsSupplierCarrierShippingMethod_disable'),
                  clickFn: () => {
                    v.stopShippingMethod(params.row.shippingMethodId);
                  }
                },
                {
                  text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002184'),
                  show: v.optionsType === 'thirdPartyLogistics' && v.getPermission('thirdPartyLogisticsChannels_update'),
                  clickFn: () => {
                    v.$refs['thirdPartyLogisticsChannels'].initThirdPartyLogisticsChannelsData(params.row);
                  }
                },
              ]
            },
            on: {
              setWidth(value) {
                if (value) {
                  v.optionBtnWidth.push(value);
                  params.column.width = Math.max(...v.optionBtnWidth);
                  v.$forceUpdate();
                }
              }
            }
          });
        }
      };
      if (apiInterface === 'API_AE_LG') {
        v.logistiChannelColumns = [
          ...columnsList,
          {
            title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005213'),
            align: 'center',
            width: 140,
            key: 'senderAddressId'
          },
          {
            title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005214'),
            align: 'center',
            width: 140,
            key: 'pickupAddressId'
          },
          {
            title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005215'),
            align: 'center',
            width: 140,
            key: 'refundAddressId'
          },
          options
        ];
      } else {
        v.logistiChannelColumns = [
          ...columnsList,
          options
        ];
      }
    },
    // 停用物流渠道
    stopShippingMethod(shippingMethodId) {
      let v = this;
      v.$Modal.confirm({
        title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002470'),
        content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007123'),
        okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000543'),
        cancelText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000112'),
        onOk: () => {
          v.axios.put(api.put_ymsSupplierCarrierShippingMethod_disable + `?shippingMethodId=${shippingMethodId}`).then(response => {
            if (response.data.code === 0) {
              v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002486'));
              v.updateData();
            }
          });
        }
      });
    },
    // 获取未启用物流方式的数据
    getLogisticsNotEnabledData(carrierId) {
      let v = this;
      v.logisticsNotEnabledData = [];
      v.axios.get(api.get_ymsSupplierCarrier_queryForCoreEnableCarriers + `?carrierId=${carrierId}`).then(response => {
        if (response.data.code === 0) {
          let data = response.data.datas || [];
          if (data.length > 0) {
            function transformDataWithAllFields(data) {
              return data.map(carrier => {
                const carrierData = {...carrier};
                const carrierShippingMethodsList = (carrier.carrierShippingMethods || []).filter(method => method.status === 1);
                const children = carrierShippingMethodsList.map(method => ({
                  ...method,
                  value: method.shippingMethodId,
                  label: _handleMultilingualFields(method.carrierShippingMethodName),
                }));
                return {
                  ...carrierData,
                  value: carrier.carrierId,
                  label: carrier.carrierName,
                  children,
                };
              });
            }

            v.logisticsNotEnabledData = transformDataWithAllFields(data);
          }
          v.logisticsNotEnabledModal = true;
        }
      });
    },
    // 启用物流商物流方式
    logisticsNotEnabledBtn() {
      let v = this;
      if (v.logisticsNotEnabledValue.length === 0) {
        v.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007124'));
        return false;
      }
      let obj = {
        carrierId: v.carrierId,
        isOwnCarrier: 1,
        shippingMethodEnableDetails: [{coreShippingMethodId: v.logisticsNotEnabledValue[v.logisticsNotEnabledValue.length - 1]}]
      };
      v.axios.put(api.put_ymsSupplierCarrierShippingMethod_enable, obj, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
        if (response.data.code === 0) {
          v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002485'));
          v.updateData();
          v.logisticsNotEnabledModal = false;
        }
      });
    },
    // 监听物流商物流方式弹窗
    logisticsNotEnabledChange(value) {
      if (!value) {
        this.logisticsNotEnabledValue = [];
      }
    },
    // 更新数据
    updateData() {
      this.getSupplierLogisticsChannelData(this.logisticsDetails);
    }
  },
  watch: {
    // 模糊搜索物流渠道名称/代码
    logisticsChannelText: {
      handler(value) {
        let newListData = [];
        if (value !== '') {
          let text = value.toLowerCase();
          if (this.logistiChannelData.length > 0) {
            this.logistiChannelData.filter(item => {
              if (item.carrierShippingMethodCode.toLowerCase().indexOf(text) !== -1 || item.carrierShippingMethodName.toLowerCase().indexOf(text) !== -1) {
                newListData.push(item);
              }
            });
            this.logistiChannelData = newListData;
          }
        } else {
          this.logistiChannelData = this.originalData;
        }
      },
      deep: true
    }
  },
  components: {
    thirdPartyLogisticsChannelsModal,
    ownLogisticsChannelsModal
  }
};
</script>

<style lang="less" scoped>
/deep/ .logisticsChannelStyle {
  position: relative;

  .filter_box {
    display: flex;
    align-items: center;
    margin: 10px 0 15px 0;
  }

  .options_boxs {
    position: absolute;
    top: -42px;
    right: 16px;
  }

  .ivu-drawer-body {
    overflow: initial !important;
  }

  .ivu-drawer .ivu-drawer-header-inner {
    font-size: 18px;
    font-weight: bold;
    color: #333;
  }
}
</style>
